import * as moment from 'moment';
import { IDonorRegistration } from '@nkr/models/index';
import { Col, Label, Row } from 'react-bootstrap';
import { getBoolean, getString } from './renderers';
import { cardBodyStyle, cardBodyTitleStyle, cardBodyTitleTextStyle, cardStyle } from '../../styles';
import React from 'react';

interface IProps {
    data: IDonorRegistration
}

const Details = (props: IProps) => {
    return (
        <div id='donor-details' style={cardStyle}>
            <div style={cardBodyStyle}>
                <div style={cardBodyTitleStyle}>
                    <span style={cardBodyTitleTextStyle}>Donor Details</span>
                </div>
                <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>Registration Date:</Col>
                    <Col xs={6} sm={2}>{props.data.registrationDateTime == '' ? '[unknown]' : moment(props.data.registrationDateTime).format('M/D/YYYY')}</Col>
                    {/* <Col xs={6} sm={4} className='item-label'>Referral Date:</Col>
                    <Col xs={6} sm={2}>{props.data.historyCompleteDateTime == null ? 'N/A' : moment(props.data.historyCompleteDateTime).format('M/D/YYYY')}</Col> */}
                </Row>

                <Row className='row-underlined row-value-right'>
                    {/* <Col xs={6} sm={4} className='item-label'>Registration Date:</Col>
                    <Col xs={6} sm={2}>{props.data.registrationDateTime == '' ? '[unknown]' : moment(props.data.registrationDateTime).format('M/D/YYYY')}</Col> */}
                    <Col xs={6} sm={4} className='item-label'>Referral Date:</Col>
                    <Col xs={6} sm={2}>{props.data.historyCompleteDateTime == null ? 'N/A' : moment(props.data.historyCompleteDateTime).format('M/D/YYYY')}</Col>
                </Row>

                <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>Expiration Date:</Col>
                    <Col xs={6} sm={2}>{props.data.expireDateTime == null ? 'N/A' : moment(props.data.expireDateTime).format('M/D/YYYY')}</Col>
                </Row>

                <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>Gender:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.gender)}</Col>
                    {/* <Col xs={6} sm={4} className='item-label'>Preferred Language:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.preferredLanguage)}</Col> */}
                </Row>

                <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={3} className='item-label'>Full Name:</Col>
                    <Col xs={6} sm={3}>{getString(props.data.fullName)}</Col>
                    {/* <Col xs={6} sm={4} className='item-label'>Preferred Name:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.preferredName)}</Col> */}
                </Row>

                <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>Preferred Language:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.preferredLanguage)}</Col>
                    {/* <Col xs={6} sm={4} className='item-label'>Is Interpreter Needed:</Col>
                    <Col xs={6} sm={2}>{getBoolean(props.data.isInterpreterNeeded)}</Col> */}
                </Row>

                <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>Phone Number:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.phoneNumber)}</Col>
                    {/* <Col xs={6} sm={4} className='item-label'>Secondary Phone:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.phoneNumberSecondary)}</Col> */}
                </Row>

                {/* <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>Contact Preference:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.contactPreference)}</Col>
                    <Col xs={6} sm={4} className='item-label'>Best Contact Time:</Col>
                    <Col xs={6} sm={2}>
                        {(props.data.contactBestStartHour) ? `${props.data.contactBestStartHour} - ${props.data.contactBestEndHour}` : '[not answered]'}
                    </Col>
                </Row> */}

                <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>Emergency Contact:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.emergencyContact)}</Col>
                    <Col xs={6} sm={4} className='item-label'>Emergency Contact #:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.emergencyContactPhone)}</Col>
                </Row>

                <Row className='row-underlined row-value-right'>
                    {/* <Col xs={6} sm={4}></Col>
                    <Col xs={6} sm={2}></Col> */}
                    <Col xs={6} sm={4} className='item-label'>Relationship to Contact:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.emergencyContactRelationship)}</Col>
                </Row>

                <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>DOB/Age:</Col>
                    <Col xs={6} sm={2}>
                        {props.data.birthDate == null ? '[not answered]' : moment(props.data.birthDate).format('MM/DD/YYYY')}&nbsp;/&nbsp;
                        <Label style={{ fontSize: '100%' }}>{props.data.age > 0 ? props.data.age : '[unknown]'}</Label>
                    </Col>
                </Row>

                <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>Country of Residence:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.countryOfResidence)}</Col>
                    <Col xs={6} sm={4} className='item-label'></Col>
                    <Col xs={6} sm={2}></Col>
                </Row>

                <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={3} className='item-label'>Address:</Col>
                    <Col xs={6} sm={3}>
                        {getString(props.data.addressLine1)}<br />
                        {getString(props.data.city)}, {getString(props.data.stateProvinceString)} {props.data.postalCode}
                    </Col>
                    {/* <Col xs={6} sm={2}>{getString(props.data.addressLine1)}</Col>
                    <Col xs={6} sm={4} className='item-label'>City:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.city)}</Col>
                </Row>

                <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>State:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.stateProvinceString)}</Col>
                    <Col xs={6} sm={4} className='item-label'>Postal Code:</Col>c
                    <Col xs={6} sm={2}>{props.data.postalCode}</Col> */}
                </Row>

                {/* <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>Height:</Col>
                    <Col xs={6} sm={2}>{props.data.heightInches != null ? <>{Math.floor(props.data.heightInches / 12)}' {props.data.heightInches % 12}''</> : '[unknown]'}</Col>
                    <Col xs={6} sm={4} className='item-label'>Weight:</Col>
                    <Col xs={6} sm={2}>{props.data.weightLbs != null ? props.data.weightLbs + 'lbs' : '[unknown]'}</Col>
                </Row> */}

                <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>Height/Weight:</Col>
                    <Col xs={6} sm={2}>
                        {props.data.heightInches != null ? <>{Math.floor(props.data.heightInches / 12)}' {props.data.heightInches % 12}''</> : '[unknown]'}&nbsp;/&nbsp;
                        {props.data.weightLbs != null ? props.data.weightLbs + 'lbs' : '[unknown]'}
                    </Col>
                </Row>

                <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>BMI:</Col>
                    <Col xs={6} sm={2}>{props.data.bmi}</Col>
                </Row>

                <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>Employment Status:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.employmentStatus)}</Col>
                    <Col xs={6} sm={4} className='item-label'>Has PTO for donation?</Col>
                    <Col xs={6} sm={2}>{getString(props.data.medicalPto)}</Col>
                </Row>

                <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>Occupation:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.occupation)}</Col>
                    <Col xs={6} sm={4} className='item-label'>Requires Heavy Lifting?</Col>
                    <Col xs={6} sm={2}>{getBoolean(props.data.occupationHasHeavyLifting)}</Col>
                </Row>

                {/* <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>Education Level:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.educationLevel)}</Col>
                    <Col xs={6} sm={4} className='item-label'>Marital Status:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.maritalStatus)}</Col>
                </Row> */}

                <Row className='row-underlined row-value-right'>
                    {/* <Col xs={6} sm={4} className='item-label'>Exercise Routine:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.exerciseRoutine)}</Col> */}
                    <Col xs={6} sm={4} className='item-label'>Health Insurance:</Col>
                    <Col xs={6} sm={2}>{getBoolean(props.data.hasHealthInsurance, false)}</Col>
                </Row>

                <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>Blood Type:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.aboType)}</Col>
                    <Col xs={6} sm={4} className='item-label'>Ethnicity/Race:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.ethnicity)}</Col>
                </Row>

                <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>Donor Type:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.donorSituation)}</Col>
                </Row>

                {/* <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>Prefer Remote Donation:</Col>
                    <Col xs={6} sm={2}>{getBoolean(props.data.isRemoteDonationPreferred, false)}</Col>
                </Row> */}

                <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>Physician:</Col>
                    <Col xs={6} sm={2}>{(props.data.physicianName != null ? props.data.physicianName : '[not answered]')}
                    </Col>
                </Row>

                {/* <Row className='row-underlined row-value-right'>
                    <Col xs={6} sm={4} className='item-label'>Motivation to donate:</Col>
                    <Col xs={6} sm={2}>{getString(props.data.motivationToDonate)}</Col>
                </Row> */}
            </div>
        </div>
    );
}

export default Details;